/* HIGHCOOL accessibility helpers (GLOBAL thread, 2026-10-01).
   1. Respects prefers-reduced-motion: autoplaying videos are paused and do not start.
   2. Adds a visible pause/play button to every autoplaying background video (WCAG 2.2.2). */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduce = !!(mq && mq.matches);
  var PAUSE = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="3" y="2" width="3.5" height="12"/><rect x="9.5" y="2" width="3.5" height="12"/></svg>';
  var PLAY = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 2l10 6-10 6z"/></svg>';

  function render(btn, video) {
    var paused = video.paused;
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    btn.innerHTML = (paused ? PLAY : PAUSE) + '<span>' + (paused ? 'Play' : 'Pause') + '</span>';
  }

  function enhance(video) {
    if (video.dataset.hcA11y) return;
    if (!video.autoplay && !video.hasAttribute('autoplay')) return;
    if (video.controls) return;
    video.dataset.hcA11y = '1';

    if (reduce) {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      try { video.pause(); } catch (e) {}
    }

    var host = video.parentElement;
    if (!host) return;
    if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hc-video-toggle';
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        video.dataset.hcUserPlay = '1';
      } else {
        video.pause();
        video.dataset.hcUserPaused = '1';
      }
    });
    video.addEventListener('play', function () {
      if (reduce && !video.dataset.hcUserPlay) { video.pause(); return; }
      render(btn, video);
    });
    video.addEventListener('pause', function () { render(btn, video); });
    host.appendChild(btn);
    render(btn, video);
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('video');
    for (var i = 0; i < list.length; i++) enhance(list[i]);
  }

  function init() {
    scan(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var nodes = records[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'VIDEO') enhance(n); else if (n.querySelector && n.querySelector('video')) scan(n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (mq) {
      var onChange = function (e) {
        reduce = e.matches;
        if (!reduce) return;
        var list = document.querySelectorAll('video[data-hc-a11y]');
        for (var i = 0; i < list.length; i++) { if (!list[i].dataset.hcUserPlay) list[i].pause(); }
      };
      if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
